import {
  fontFamilyBase,
  colorInterfaceDarkDeep,
  colorInterfaceLightDown,
  colorBrandPrimaryPure,
} from "@useblu/ocean-tokens/web/tokens";
import styled, { StyledProps, css } from "styled-components";

type AccordionProps = StyledProps<{
  isOpen: boolean;
}>;

export const AccordionTitleContent = styled.div`
  border-bottom: ${(props: AccordionProps) =>
    props.isOpen ? "none" : `1px solid ${colorInterfaceLightDown}`};
  padding: 16px 40px 16px 16px;
  position: relative;
  cursor: pointer;

  p {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: ${(props:AccordionProps) =>
      props.isOpen ? colorBrandPrimaryPure : colorInterfaceDarkDeep};
    font-weight: 600;
  }

  .custom-chevron {
    margin: auto;
    position: absolute;
    right: 15px;
    bottom: 0;
    top: 0;
    color: ${(props:AccordionProps) =>
      props.isOpen ? colorBrandPrimaryPure : colorInterfaceDarkDeep};
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  }

  &:hover {
    p,
    .custom-chevron {
      color: ${colorBrandPrimaryPure};
    }
  }
`;

export const AccordionDescriptionContent = styled.div`
  padding: 0 16px;
  min-height: 0px;
  height: 0px;
  visibility: hidden;
  color: #67697a;

  ${(props: AccordionProps) =>
    props.isOpen &&
    css`
      transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      transition-duration: 100ms;
      height: auto;
      padding: 16px;
      visibility: inherit;
      border-bottom: 1px solid ${colorInterfaceLightDown};
    `}

  p {
    margin: 0;
    font-size: 14px;
    line-height: 21px;
    font-family: ${fontFamilyBase};
    color: #393b47;
  }
`;
